import React from 'react';
import './index.less';
import classNames from 'classnames';

export interface SimpleNoteProps {
  style?: React.CSSProperties;
  className?: string;
  children: React.ReactNode;
}

function SimpleNote(props: SimpleNoteProps) {
  const { style, className, children } = props;
  const simpleNoteClass = classNames('simple-note__font', className);
  return (
    <div className={simpleNoteClass} style={style}>
      {children}
    </div>
  );
}

export default SimpleNote;
